import React from "react"
import {
  ActionRow,
  Comment,
  IconWrapper,
  Reference,
  SmallInfo,
  StateDate,
  UserIcon
} from "./CustomerOrderTable.styled"
import dayjs from "dayjs"
import { OrderHistoryLogEntry } from "lib/types/generated/graphql-types"

type Props = {
  entry: OrderHistoryLogEntry
}

const CommentRow = ({ entry }: Props) => {
  const getInitials = (userName: string) => {
    if (userName.includes("@")) {
      const name = userName.split("@")
      if (name[0].includes(".")) {
        const fragments = name[0].split(".")
        return `${fragments[0].slice(0, 1)}${fragments[1].slice(0, 1)}`
      }
    }
    return userName.slice(0, 1)
  }

  return (
    <ActionRow>
      <Reference>
        <IconWrapper>
          <UserIcon>{getInitials(entry?.actor?.name ?? "")}</UserIcon>
        </IconWrapper>
        <Comment>
          <b>{entry?.comment?.text}</b>
          <SmallInfo>{entry?.actor?.name}</SmallInfo>
        </Comment>
      </Reference>
      <StateDate className={"hideOnSmallScreens"}>
        <div>
          <span>
            <b>{dayjs(entry?.timestamp).format("YYYY-MM-DD")}</b>
          </span>
          <span>{dayjs(entry?.timestamp).format("HH:mm")}</span>
        </div>
      </StateDate>
    </ActionRow>
  )
}

export default CommentRow
